import { CampaignLink } from 'modules/SmartCampaignLinks/shared/types';

import { DummyStore } from 'stores';

import { TransactionResponse } from '../types';

export const campaignLinkOrderStore = new DummyStore<TransactionResponse>();
export const campaignLinkStore = new DummyStore<CampaignLink>();
